<template>
    <div class="weekly-schedule">
        <div class="td-table-container">
            <table cellspacing="0" cellpadding="0" class="td-table">
                <thead>
                    <tr class="table-header hours-row">
                        <th class="pl-1">Day</th>
                        <th>Status</th>
                        <th>Open Hours</th>
                        <th>Limited Services</th>
                        <th class="pr-1"></th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(day, key, index) in allEntries" :key="key">
                        <tr class="table-row hours-row">
                            <td class="pl-1 td-text-secondary">
                                <label class="td-checkbox-label my-1" :for="`enable-${key}`">
                                    <strong>{{ key }}</strong>
                                    <input :id="`enable-${key}`"
                                           :name="`enable-${key}`"
                                           type="checkbox"
                                           :checked="day.enabled"
                                           @change="toggleEnable(key)" />
                                    <span></span>
                                </label>
                            </td>
                            <td>
                                <span v-if="hasAfterHoursOnly(allEntries[key], day.afterHours24)"
                                      class="td-badge td-text-danger slim error no-icon">
                                    After Hours
                                </span>

                                <span v-else-if="day.enabled"
                                      class="td-badge success slim no-icon td-text-success">
                                    Open
                                </span>

                                <span v-else
                                      class="td-badge td-text-danger slim error no-icon">
                                    Closed
                                </span>
                            </td>

                            <td>
                                <strong class="show-mobile mr-1">Open Hours</strong>
                                <template v-if="allEntries[key]?.enabled">
                                    <div v-for="(entry, i) in getEntries(allEntries[key], HoursOfOperationDisplayType.Open)"
                                      :key="`${key}-${i}-${entry.type}`"
                                         class="hours-entry">

                                        <div>
                                            <input type="time"
                                                   v-model="entry.startTime"
                                                   :class="[{ error: hasStartTimeError(key, HoursOfOperationDisplayType.Open, i) }, 'td-input']"
                                                   @change="editStartTime(entry, key, HoursOfOperationDisplayType.Open, i)" />
                                        </div>

                                        <div>-</div>
                                        <div>
                                            <input type="time"
                                                   v-model="entry.endTime"
                                                   :class="[{ error: hasEndTimeError(key, HoursOfOperationDisplayType.Open, i) }, 'td-input']"
                                                   @change="editEndTime(entry, key, HoursOfOperationDisplayType.Open, i)" />
                                            <div v-if="requireMidnightSplit(entry.startTime, entry.endTime)"
                                                 class="td-badge secondary mt-1">
                                                Next Day
                                            </div>
                                        </div>

                                        <button @click="updateEntry(entry, key, HoursOfOperationDisplayType.Open, i)"
                                                v-if="isEntryModified(entry)" class="success td-text-success td-btn icon-only">
                                            <icon type="solid" name="faCheck" />
                                        </button>
                                        <button @click="removeTimeEntry(key, entry)" class="danger td-btn icon-only">
                                            <icon type="solid" name="faTrashCan" />
                                        </button>

                                        <div class="errors">
                                            <error v-if="timeValidators[`${key}-${HoursOfOperationDisplayType.Open}-${i}`]?.errors[`startTime-${key}-${HoursOfOperationDisplayType.Open}-${i}`]"
                                                   :error="timeValidators[`${key}-${HoursOfOperationDisplayType.Open}-${i}`].errors[`startTime-${key}-${HoursOfOperationDisplayType.Open}-${i}`]"></error>
                                            <error v-if="timeValidators[`${key}-${HoursOfOperationDisplayType.Open}-${i}`]?.errors[`endTime-${key}-${HoursOfOperationDisplayType.Open}-${i}`]"
                                                   :error="timeValidators[`${key}-${HoursOfOperationDisplayType.Open}-${i}`].errors[`endTime-${key}-${HoursOfOperationDisplayType.Open}-${i}`]"></error>
                                            <error v-if="timeValidators[`${key}-${HoursOfOperationDisplayType.Open}-${i}`]?.errors[`overlap-${key}-${HoursOfOperationDisplayType.Open}-${i}`]"
                                                   :error="timeValidators[`${key}-${HoursOfOperationDisplayType.Open}-${i}`].errors[`overlap-${key}-${HoursOfOperationDisplayType.Open}-${i}`]"></error>
                                            <error v-if="timeValidators[`${key}-${HoursOfOperationDisplayType.Open}-${i}`]?.errors[`range-${key}-${HoursOfOperationDisplayType.Open}-${i}`]"
                                                   :error="timeValidators[`${key}-${HoursOfOperationDisplayType.Open}-${i}`].errors[`range-${key}-${HoursOfOperationDisplayType.Open}-${i}`]"></error>
                                        </div>
                                    </div>
                                </template>
                               
                            </td>

                            <td>
                                <strong class="show-mobile"
                                        v-if="!day.afterHours24">
                                    After Hours
                                </strong>
                                <template v-if="!day.afterHours24 && day.enabled">
                                    <div 
                                         v-for="(entry, i) in getEntries(allEntries[key], HoursOfOperationDisplayType.AfterHours)"
                                        :key="`${key}-${i}-${entry.type}`"
                                         class="hours-entry">
                                        <div>
                                            <input type="time"
                                                   v-model="entry.startTime"
                                                   :class="[{ error: hasStartTimeError(key, HoursOfOperationDisplayType.AfterHours, i) }, 'td-input']"
                                                   @blur="editStartTime(entry, key, HoursOfOperationDisplayType.AfterHours, i)" />
                                        </div>
                                        <div>-</div>
                                        <div>
                                            <input type="time" v-model="entry.endTime"
                                                   :class="[{ error: hasEndTimeError(key, HoursOfOperationDisplayType.AfterHours, i) }, 'td-input']"
                                                   @change="editEndTime(entry, key, HoursOfOperationDisplayType.AfterHours, i)" />
                                            <div v-if="requireMidnightSplit(entry.startTime, entry.endTime)"
                                                 class="td-badge secondary mt-1">
                                                Next Day
                                            </div>
                                        </div>
                                        <button v-if="isEntryModified(entry)" class="success td-text-success td-btn icon-only"
                                                @click="updateEntry(entry, key, HoursOfOperationDisplayType.AfterHours, i)">
                                            <icon type="solid" name="faCheck" />
                                        </button>

                                        <button @click="removeTimeEntry(key, entry)" class="danger td-btn icon-only">
                                            <icon type="solid" name="faTrashCan" />
                                        </button>
                                        <div class="errors">
                                            <error v-if="timeValidators[`${key}-${HoursOfOperationDisplayType.AfterHours}-${i}`]?.errors[`startTime-${key}-${HoursOfOperationDisplayType.AfterHours}-${i}`]"
                                                   :error="timeValidators[`${key}-${HoursOfOperationDisplayType.AfterHours}-${i}`].errors[`startTime-${key}-${HoursOfOperationDisplayType.AfterHours}-${i}`]"></error>
                                            <error v-if="timeValidators[`${key}-${HoursOfOperationDisplayType.AfterHours}-${i}`]?.errors[`endTime-${key}-${HoursOfOperationDisplayType.AfterHours}-${i}`]"
                                                   :error="timeValidators[`${key}-${HoursOfOperationDisplayType.AfterHours}-${i}`].errors[`endTime-${key}-${HoursOfOperationDisplayType.AfterHours}-${i}`]"></error>
                                            <error v-if="timeValidators[`${key}-${HoursOfOperationDisplayType.AfterHours}-${i}`]?.errors[`overlap-${key}-${HoursOfOperationDisplayType.AfterHours}-${i}`]"
                                                   :error="timeValidators[`${key}-${HoursOfOperationDisplayType.AfterHours}-${i}`].errors[`overlap-${key}-${HoursOfOperationDisplayType.AfterHours}-${i}`]"></error>
                                            <error v-if="timeValidators[`${key}-${HoursOfOperationDisplayType.AfterHours}-${i}`]?.errors[`range-${key}-${HoursOfOperationDisplayType.AfterHours}-${i}`]"
                                                   :error="timeValidators[`${key}-${HoursOfOperationDisplayType.AfterHours}-${i}`].errors[`range-${key}-${HoursOfOperationDisplayType.AfterHours}-${i}`]"></error>
                                        </div>
                                    </div>
                                </template>
                                <label class="td-checkbox-label my-1" :for="`24hours-${key}`">
                                    24 hours {{hoursType.toLowerCase()}}
                                    <input :name="`24hours-${key}`"
                                            :id="`24hours-${key}`"
                                            type="checkbox"
                                            v-model="day.afterHours24"
                                            @change="select24(key)" />
                                    <span></span>
                                </label>
                            </td>

                            <td class="show-mobile"></td>
                            <td class="pr-1 td-text-right">
                               
                                <button @click.prevent="addTimeEntry(key)" class="secondary-outlined td-btn td-text-mice slim icon-left">
                                    <icon type="solid" name="faPlus"></icon>Add Time
                                </button>
                            </td>

                        </tr>
                        <tr v-if="entryToAdd[key]" class="hours-row add-record table-row">
                            <td colspan="2" class="pl-1">
                                <div class="td-radio background ml-0">
                                    <label :for="'open-time' + key">
                                        <input type="radio"
                                               v-model="entryToAdd[key].type"
                                                :id="'open-time' + key"
                                                :name="'open-time' + key"
                                               :disabled="!day.enabled"
                                               :value="HoursOfOperationDisplayType.Open" />
                                        <span>Open </span>
                                    </label>

                                    <label :for="'after-time' + key">
                                        <input type="radio"
                                               v-model="entryToAdd[key].type"
                                               :id="'after-time' + key"
                                               :name="'after-time' + key"
                                               :value="HoursOfOperationDisplayType.AfterHours"
                                               :disabled="!day.enabled" />
                                        <span>After Hours </span>
                                    </label>
                                </div>
                            </td>
                            <td colspan="2">
                                <div class="hours-entry">
                                    <input type="time" v-model="entryToAdd[key].startTime" class="td-input" />
                                    -
                                    <input type="time" v-model="entryToAdd[key].endTime" class="td-input" />
                                </div>
                               
                            </td>
                           <td class="show-mobile"></td>
                           <td class="icons-actions pr-1">
                               <button @click.prevent="confirmEntryAdd(key)" class="td-btn icon-only td-text-success success mr-1"><icon type="solid" name="faCheck"></icon></button>
                               <button @click.prevent="discardEntryAdd(key)" class="td-btn icon-only danger"><icon type="solid" name="faTrashCan"></icon></button>
                           </td>
                        </tr>
                    </template>
                   
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import script from './WeeklySchedule';
    export default script;</script>

<style lang="less">
    @import "./WeeklySchedule.less";
</style>